var map = {
	"./Thumbs.db": 6635,
	"./comingSoon.png": 5940,
	"./home.jpg": 3834,
	"./inicio.png": 7109,
	"./logo enma.svg": 6617,
	"./logo.png": 1053,
	"./proyecto-1-com.png": 5426,
	"./proyecto-1.png": 3775,
	"./proyecto-2-com.png": 5080,
	"./proyecto-2.png": 5895,
	"./proyecto-3-com.png": 6296,
	"./proyecto-3.png": 7118,
	"./proyecto-4-com.png": 8396,
	"./proyecto-4.png": 7364,
	"./proyecto-5-com.png": 3790,
	"./proyecto-5.png": 6007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;